/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Logon_NameInputs */

const en_tables_pause_reasons_logon_name = /** @type {(inputs: Tables_Pause_Reasons_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Logon Name`)
};

const de_tables_pause_reasons_logon_name = /** @type {(inputs: Tables_Pause_Reasons_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldename`)
};

/**
* | output |
* | --- |
* | "Reasons Logon Name" |
*
* @param {Tables_Pause_Reasons_Logon_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_logon_name = /** @type {((inputs?: Tables_Pause_Reasons_Logon_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Logon_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_logon_name(inputs)
	return de_tables_pause_reasons_logon_name(inputs)
});